import React, { Component } from "react";
import PropTypes from "prop-types";
import { get } from "lodash";
import produce from "immer";
import StoryCard from "../shared/story-card";
import Breadcrumb from "../shared/breadcrumbs";
import styles from "../text-story-page/styles.m.css";
import PhotoAlbum from "../../../../rows/photo-album";
import StoryMidPromotion from "../../storyMidContent";
import stylesPA from "./styles.m.css";
import { humanizeDate } from "../../../../utils/time-format";
import { VikatanResponsiveContainer, PGAdwithAd } from "../../../../rows/ad-free";
import Media from "react-media";
import { Link } from "@quintype/components";
import Icon from "../../../../atoms/icon";
import { fetchvuuklegetCommentCount } from "../../../../../api";

class PhotoAlbumStory extends Component {
  constructor() {
    super();
    this.state = {
      userType: "F",
      commentsCount: null,
      showShare: false,
      showMore: false
      // showIplArticleBanner: false
    };
    this.handleSlideChange = this.handleSlideChange.bind(this);
    this.fetchCommentsCount = this.fetchCommentsCount.bind(this);
    this.handleShowMore = this.handleShowMore.bind(this);
    this.handleShareClick = this.handleShareClick.bind(this);
  }

  componentDidMount() {
    global.userPromise.catch(() => ({})).then(user => {
      user && this.setState({ userType: user.userType });
    });
    this.fetchCommentsCount();
    // this.checkDomain();
  }

  // checkDomain() {
  //   const allowedDomain = "sports.vikatan.com";
  //   const hostname = global.location.hostname || "";
  //   this.setState({ showIplArticleBanner: hostname === allowedDomain });
  // }

  fetchCommentsCount() {
    const storyId = this.props.story.id;
    fetchvuuklegetCommentCount(storyId)
      .then(res => {
        this.setState({ commentsCount: res.data });
      })
      .catch(error => {
        console.error("Error fetching comments count:", error);
      });
  }

  handleSlideChange(index) {
    if (this.firstPhotoAlbumElement) {
      const imageStoryElements = this.firstPhotoAlbumElement["story-elements"];
      const currentImageElement = imageStoryElements[index];
      const completeStorySlugArray = this.props.story.slug.split("/");
      const storySlug = completeStorySlugArray.splice(-1);
      const combinedSlug = `/${completeStorySlugArray.join("/")}/__${currentImageElement.id.replace(
        /-/g,
        ""
      )}__${storySlug}`;
      window.history.replaceState({}, "", combinedSlug);
      this.props.fireVirtualPageView();
    }
  }

  handleShowMore() {
    this.setState(prevState => ({
      showMore: !prevState.showMore
    }));
  }

  handleShareClick() {
    this.setState(prevState => ({
      showShare: !prevState.showShare
    }));
  }

  render() {
    const { commentsCount, showShare } = this.state;
    const renderarticleFooter = get(this.props, ["renderarticleFooter"], () => null);
    const renderFooter = get(this.props, ["renderFooter"], () => null);
    const renderSidebar = get(this.props, ["renderSidebar"], () => null);
    const renderHeaderCard = get(this.props, ["renderHeaderCard"], () => null);
    const storyHeadline = get(this.props, ["story", "subheadline"], () => null);
    const renderSocialMedia = get(this.props, ["renderSocialMedia"], () => null);
    const section = get(this.props, ["story", "sections", "0"], null);
    const story = get(this.props, ["story"], () => null);
    const { userType } = this.state;
    const readMore = false;

    const expandComments = get(this.props, ["expandComments"], () => null);
    const storyId = get(this.props, ["story", "id"], "");

    const firstPhotoAlbumElement = this.props.story.cards
      .reduce((acc, currEle) => {
        acc = acc.concat(currEle["story-elements"]);
        return acc;
      }, [])
      .find(({ subtype }) => subtype === "image-gallery");

    this.firstPhotoAlbumElement = firstPhotoAlbumElement;

    const renderHeaderPhotoAlbum = () => {
      if (!firstPhotoAlbumElement) {
        return null;
      }
      return (
        <PhotoAlbum storyElement={firstPhotoAlbumElement} onSlideChange={this.handleSlideChange} pagetype="story" />
      );
    };

    const scrollToComments = () => {
      expandComments();
      const commentsWidgetContainer = document.getElementById("commentsWidgetContainer");
      if (commentsWidgetContainer) {
        commentsWidgetContainer.scrollIntoView({ behavior: "smooth" });
      }
    };

    // const iplArticleBanner = showIplArticleBanner ? (
    //   <div className={styles["ipl-article-banner"]}>
    //     <div className="hidden-mobile">
    //       <a
    //         href="https://sports.vikatan.com/olympics?utm_source=story_banner"
    //         rel="noopener noreferrer"
    //         target="_blank"
    //       >
    //         <img
    //           src="https://media.vikatan.com/vikatan/2024-08/b7ae3920-036e-448a-91a2-de23e2c8021e/Vikatan_Sathya_Paris_olympics_article_top_banner_700x120.png"
    //           alt=""
    //         />
    //       </a>
    //     </div>
    //     <div className="hidden-desktop">
    //       <a
    //         href="https://sports.vikatan.com/olympics?utm_source=story_banner"
    //         rel="noopener noreferrer"
    //         target="_blank"
    //       >
    //         <img
    //           src="https://media.vikatan.com/vikatan/2024-08/b7ae3920-036e-448a-91a2-de23e2c8021e/Vikatan_Sathya_Paris_olympics_article_top_banner_375x120.png"
    //           alt=""
    //         />
    //       </a>
    //     </div>
    //   </div>
    // ) : null;

    return (
      <div className={`page-content`}>
        <div className={`container ${styles["story-grid"]}`}>
          <div className={styles["main-content"]}>
            <article className={`${styles["story-body"]} js-story`}>
              {/* <div>{iplArticleBanner}</div> */}
              <Breadcrumb subSection={section} config={this.props.config} />
              {renderHeaderCard({ className: stylesPA["story-header"] }, true, true)}
              <p className={`${styles["subheadline"]} subheadline-main`}>{storyHeadline}</p>
              <div className={styles["published-time-wrap"]}>
                {story["first-published-at"] && (
                  <span className={styles["published"]}>
                    Published:
                    <time className={styles.time} dateTime={new Date(story["first-published-at"]).toISOString()}>
                      {humanizeDate(story["first-published-at"], "relative")}
                    </time>
                  </span>
                )}
                {story["last-published-at"] && (
                  <span className={styles["updated"]}>
                    Updated:
                    <time className={styles.time} dateTime={new Date(story["last-published-at"]).toISOString()}>
                      {humanizeDate(story["last-published-at"], "relative")}
                    </time>
                  </span>
                )}
              </div>

              <div className={styles["audio-share-wrapper"]}>
                <div className={styles["audio-comments-share"]}>
                  <div>
                    <Link
                      href="https://whatsapp.com/channel/0029Va7F0Hj0bIdoYCCkqs41"
                      target="_blank"
                      rel="noopener noreferrer"
                      className={styles["box-div"]}
                    >
                      <Icon type="icon-whatsapp" className={styles["whatsapp-channel-icon"]} />
                      <span className={styles["channel-txt"]}>Join Our Channel</span>
                    </Link>
                    {/* <Link
                      href="https://bit.ly/3J0OoJc"
                      target="_blank"
                      rel="noopener noreferrer"
                      className={`${styles["box-div"]} ${styles["play-to-win"]}`}
                      style={{ padding: "0" }}
                    >
                      <img src="https://media.vikatan.com/vikatan/2024-03/2455867c-ef84-491e-be25-abd7a1e00de2/Play_to_win.gif" />
                    </Link> */}
                  </div>

                  <div className={styles["box-div"]} onClick={scrollToComments}>
                    <Icon type="comment" />
                    <span className={styles["channel-txt"]}>
                      {commentsCount !== null ? commentsCount[storyId] || 0 : 0}
                    </span>
                    <span className={`${styles["channel-txt"]} hidden-mobile`}>Comments</span>
                  </div>
                  <div
                    className={`${styles["box-div"]} ${showShare ? styles["share-active"] : ""} `}
                    onClick={this.handleShareClick}
                  >
                    <Icon type="socialshare" />
                    <span className={`${styles["channel-txt"]} hidden-mobile`}>Share</span>
                  </div>
                </div>

                <div className={styles["social-share-wrapper"]}>
                  {showShare && !readMore && renderSocialMedia("", false)}
                </div>
              </div>

              {renderHeaderPhotoAlbum()}
              <div className="vikatan-top-ad-width ad">
                <div className="ad-container vikatan-top-ad">
                  <Media query="(max-width:768px)">
                    {matches =>
                      matches ? (
                        <div
                          className={`mobile ${
                            userType === "P" || userType === "T" || userType === "R" ? "" : "ad_300_250"
                          }`}
                        >
                          <PGAdwithAd
                            adId={`Vikatan2023_Mobile_AP_ATF_336x280`}
                            adSize={[[336, 280], [300, 250]]}
                            minHeight={280}
                            adDivId={`div-ad-desk-3849069-1690281384`}
                            class="ad_300_250"
                            story={this.props.story}
                          />
                        </div>
                      ) : null
                    }
                  </Media>
                </div>
              </div>
              {this.props.story.cards.map((card, index) => {
                const newCard = produce(card, draft => {
                  draft["story-elements"] = draft["story-elements"].filter(
                    element => element.id !== (firstPhotoAlbumElement && firstPhotoAlbumElement.id)
                  );
                });
                return (
                  <React.Fragment key={newCard.id}>
                    <VikatanResponsiveContainer
                      placement={"text-story"}
                      adtype={parseInt(index + 1)}
                      storyId={this.props.story.id}
                      className="ad_300_250"
                      story={this.props.story}
                    />

                    {index === 1 && <StoryMidPromotion story={this.props.story} />}

                    <StoryCard key={newCard.id} card={newCard} story={this.props.story} config={this.props.config} />
                  </React.Fragment>
                );
              })}
              <div id="we-story-end" />
              <div id="commentsWidgetContainer">{renderarticleFooter()}</div>
            </article>
            {renderFooter()}
          </div>
          {renderSidebar()}
        </div>
      </div>
    );
  }
}

const story = PropTypes.shape({
  id: PropTypes.string,
  authors: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
      slug: PropTypes.string,
      "avatar-url": PropTypes.string,
      "avatar-s3-key": PropTypes.string,
      "twitter-handle": PropTypes.string,
      bio: PropTypes.string
    })
  ),
  contributors: PropTypes.arrayOf(
    PropTypes.shape({
      "role-name": PropTypes.string,
      authors: PropTypes.arrayOf(
        PropTypes.shape({
          name: PropTypes.string
        })
      )
    })
  ),
  headline: PropTypes.string.isRequired,
  alternative: PropTypes.shape({
    home: PropTypes.shape({
      default: PropTypes.shape({
        headline: PropTypes.string
      })
    })
  }),
  slug: PropTypes.string.isRequired,
  "hero-image-metadata": PropTypes.shape({
    height: PropTypes.number,
    width: PropTypes.number,
    "aspect-ratio": PropTypes.arrayOf(PropTypes.number)
  }),
  "hero-image-s3-key": PropTypes.string,
  "hero-image-caption": PropTypes.string,
  cards: PropTypes.arrayOf(StoryCard.propTypes.card),
  "linked-stories": PropTypes.any
});

PhotoAlbumStory.propTypes = {
  story: story,
  config: Breadcrumb.propTypes.config,
  renderAuthorDetails: PropTypes.func,
  renderComments: PropTypes.func,
  renderReactions: PropTypes.func,
  renderSidebar: PropTypes.func,
  renderSocialMedia: PropTypes.func,
  renderTags: PropTypes.func,
  fireVirtualPageView: PropTypes.func
};
export { PhotoAlbumStory };
